/**
 * @fileoverview A function for getting potential matches from Google.
 *
 * @author Stephanie Yoon (steyoon@yext.com)
 */

import Uri from 'goog:goog.Uri';

import {Routes} from '/src/com/yext/listingslaunchstorm/js/routes';

import {doRequest} from '/src/com/yext/listingslaunchstorm/js/common/util/dorequest';
import {GetGoogleMatchesRequest} from '/src/com/yext/listingslaunchstorm/js/data/getgooglematchesrequest';
import {GetGoogleMatchesResponse} from '/src/com/yext/listingslaunchstorm/js/data/getgooglematchesresponse';
import {ResponseError} from '/src/com/yext/listingslaunchstorm/js/data/responseerror';


/**
  * @param {!GetGoogleMatchesRequest} request
  * @param {AbortSignal} abortSignal
  * @return {!Promise<!ResponseError<GetGoogleMatchesResponse>>}
  */
export const getGoogleMatches = (request, abortSignal) => {
  const uri = new Uri(Routes.getGoogleMatches());
  return doRequest('getGoogleMatches', abortSignal, uri, 'POST', request.toJSON())
    .then(response => ResponseError.fromJSON(response, GetGoogleMatchesResponse.fromJSON));
};
